import React from 'react';

// Neutral stand-ins for data no read provides yet. A placeholder says "nothing here
// yet", never a plausible value: the copy below is fixed text, not a default that
// could be mistaken for a fact, and each disabled control names why it is disabled in
// its `title`. Each one is an item in the backend request, so removing the
// placeholder is a matter of the field arriving.

/** A field with no value. */
export const NOT_SET = '-';
export const INDUSTRY_PLACEHOLDER = 'Industry not set';
export const TIMEZONE_PLACEHOLDER = 'Timezone not set';

export const ASSIGN_OWNER_TITLE = 'Assigning an account owner needs backend support and is not available yet.';
export const ACCEPT_OWNER_TITLE = 'Accepting a suggested owner needs backend support and is not available yet.';
export const OWNER_UNKNOWN_TITLE = "This client's account owner is not available yet.";
export const SUBSCRIPTION_UNKNOWN_TITLE = 'Subscription status is not available yet.';
export const SUGGESTED_CONTACT_TITLE = 'Suggested contact: the person most likely to reply. No primary contact is on file.';
export const NO_OWNER_SUGGESTION = 'No owner suggestion yet';

/**
 * Muted stand-in text. `dim` also italicises: the placeholder must read quieter than
 * real values without dropping under the AA contrast the real muted text keeps.
 *
 * @param {object} props
 * @param {string} [props.title]      Why there is nothing here.
 * @param {boolean} [props.dim]       Italic, for sentence-style placeholders ("Industry not set").
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export function Placeholder({ title, dim = false, className = '', children }) {
  return (
    <span
      data-placeholder
      title={title}
      className={`text-gray-500 dark:text-gray-400 ${dim ? 'italic' : ''} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
